<div class="row">
  <div  *ngFor="let booth of booths">
    
    <div class="d-flex align-items-center gap-2 p-3">
      
      <!-- Icon -->
      <i class="bi bi-shop text-black"></i>

      <!-- Content -->
      <div class="small">
        <span class="fw-semibold fw-boldest">
          Booth: {{ booth?.boothNumber || '-' }}
        </span>

        <span class="text-muted mx-1">|</span>

        <span class="text-muted">
          {{ booth?.location?.name || '-' }}
        </span>

        <span class="text-muted mx-1">|</span>

        <span class="text-muted">
          {{ booth?.floor?.name || '-' }}
        </span>
      </div>

    </div>

  </div>
</div>
